// @flow
import React, {useCallback, useState} from 'react';
import {makeStyles} from '@material-ui/core';

import TaskItem from './TaskList/TaskItem';
import TaskList from './TaskList/TaskList';
import NewTaskModal from '../../../Modals/NewTaskModal';

import type {Theme} from '@material-ui/core';
type Props = {};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}));

export default function TaskContent(props: Props) {
  const classes = useStyles();

  const [isNewTaskOpen, setIsNewTaskOpen] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    setIsNewTaskOpen(false);
  }, []);

  return (
    <div className={classes.root}>
      <TaskList>
        <TaskItem description="Pasear al perro" />
        <TaskItem description="Pasear al perro" />
        <TaskItem description="Pasear al perro" />
        <TaskItem description="Pasear al perro" />
      </TaskList>
      <NewTaskModal open={isNewTaskOpen} handleClose={handleClose} />
    </div>
  );
}

TaskContent.propTypes = {};
